import { useFlags } from 'launchdarkly-react-client-sdk'
import { AlertBanner } from '@/components/AlertBanner'
import { AlertCircle } from 'lucide-react'
import useGlobalStore from '@/store/useGlobalStore'
import { getAuthCookie } from '@/lib/utils/shared/cookies/getAuthCookie'
import { AnnouncementBanner } from '../AnnouncementBanner'

export const SystemStatusBanner = () => {
  const {
    app: { language },
  } = useGlobalStore()

  // TODO: Look into making Launch Darkly type-safe
  const { bannerMessage } = useFlags()

  const authCookie = getAuthCookie()

  return (
    <>
      {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        bannerMessage?.status === 'maintenance' &&
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          bannerMessage[language] && (
            <AlertBanner
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
              text={bannerMessage[language]}
              className="bg-secondary"
              iconComponent={AlertCircle}
            />
          )
      }

      {authCookie &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        bannerMessage?.status === 'announcement' &&
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        bannerMessage[language] && (
          <AnnouncementBanner
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            text={bannerMessage[language]}
            className="bg-secondary"
            iconComponent={AlertCircle}
          />
        )}
    </>
  )
}
